import * as React from 'react';

import { NavMain } from '@src/design-system/molecules/nav-main';
import {
  Sidebar,
  SidebarContent,
  SidebarHeader,
  useSidebar,
} from '@src/design-system/sidebar';
import { Logo } from '@shared/assets/icons/shared/logo';

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  const { open } = useSidebar();

  return (
    <Sidebar
      collapsible='icon'
      {...props}
    >
      <SidebarHeader className='border-b border-primary-900 flex justify-center px-4 mb-6 h-[83px]'>
        <Logo open={open} />
      </SidebarHeader>

      <SidebarContent>
        <NavMain />
      </SidebarContent>
    </Sidebar>
  );
}
